import { render, staticRenderFns } from "./simpleScaleItem.vue?vue&type=template&id=2297176d"
import script from "./simpleScaleItem.vue?vue&type=script&lang=js"
export * from "./simpleScaleItem.vue?vue&type=script&lang=js"
import style0 from "./simpleScaleItem.vue?vue&type=style&index=0&id=2297176d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports